var render = function render(){
  var _vm$message, _vm$message2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "flex-nowrap ma-n1",
    class: {
      'mt-n3': _vm.isItemSequent
    },
    attrs: {
      "justify": "start"
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    style: {
      opacity: _vm.isItemSequent ? 0 : 1
    },
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "grey lighten-4",
      "size": "28px"
    }
  }, [_c('v-img', {
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function () {
        return [_c('v-icon', {
          attrs: {
            "small": "",
            "color": "grey lighten-1"
          }
        }, [_vm._v(" mdi-robot ")])];
      },
      proxy: true
    }])
  })], 1)], 1), _c('v-col', {
    staticClass: "pa-1"
  }, [_c('v-row', {
    staticClass: "ma-n1 flex-nowrap",
    attrs: {
      "align": "end"
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    staticStyle: {
      "max-width": "calc(100% - 36px)"
    },
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "grey lighten-4",
      "flat": "",
      "min-height": "36"
    }
  }, [_c('v-card-text', {
    staticClass: "py-2 px-3 text-caption",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [!!((_vm$message = _vm.message) !== null && _vm$message !== void 0 && _vm$message.content) ? [_vm._v(" " + _vm._s((_vm$message2 = _vm.message) === null || _vm$message2 === void 0 ? void 0 : _vm$message2.content) + " ")] : [_c('v-progress-circular', {
    attrs: {
      "size": "18",
      "width": "2",
      "color": "primary",
      "indeterminate": ""
    }
  })]], 2)], 1)], 1), _c('v-col', {
    staticClass: "pa-1",
    style: {
      opacity: _vm.isTimeSequent ? 0 : 1
    },
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "text-caption"
  }, [_vm._v(" " + _vm._s(_vm.time) + " ")])])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }